import { memo } from 'react';
import { Dialog } from '@picsart/design-system/components/Dialog';
import { useTranslator } from '@picsart/rc/services/localization';
import type { ConfirmDialogProps } from './types';

const ConfirmDialogComponent = ({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  zIndex,
}: ConfirmDialogProps) => {
  const translate = useTranslator();

  return (
    <Dialog
      dataTestId="confirm-dialog"
      type="confirmation"
      title={title}
      description={message}
      isShown
      onClose={onCancel}
      zIndex={zIndex}
      primaryParams={{
        title: confirmLabel ?? translate('Delete'),
        onClick: onConfirm,
        skin: 'error',
      }}
      secondaryParams={{
        title: cancelLabel ?? translate('Cancel'),
        onClick: onCancel,
        skin: 'information',
      }}
    />
  );
};

const ConfirmDialog = memo(ConfirmDialogComponent);
export default ConfirmDialog;
